'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = require('../../module');

var _module3 = _interopRequireDefault(_module2);

var _utils = require('../../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var log = (0, _utils.getLog)('[WinresAsk]');

var WinresAskController = function () {
    function WinresAskController($uibModal, urlService, departureService) {
        _classCallCheck(this, WinresAskController);

        this.$uibModal = $uibModal;
        this.urlService = urlService;
        this.departureService = departureService;

        this.showContent = false;
        this.showUnavailable = false;
    }

    _createClass(WinresAskController, [{
        key: '$onInit',
        value: function $onInit() {
            var params = this.urlService.readUrlParams(true);

            if (params && params.si !== undefined && params.si >= 0) {
                log('Stop ID detected.');
                this.checkWithStop(params);
            } else {
                log('No stop ID detected.');
                this.askStop(params);
            }
        }
    }, {
        key: 'checkWithStop',
        value: function checkWithStop(params) {
            var _this = this;

            log('Checking departure availability with the stop.');

            var r = this.departureService.checkDeparture(params.dc, params.bd, params.ed, params.si);
            r.then(function (blockers) {
                if (blockers === null) {
                    // Canceled
                } else if (blockers.length === 0) {
                    log('The departure is available with the stop.');
                    log('Showing content.');
                    _this.showContent = true;
                } else {
                    // Check without stop to find out if the stop is the problem.
                    log('The departure is unavailable with the stop.');
                    _this.checkWithoutStop(params);
                }
            });
        }
    }, {
        key: 'checkWithoutStop',
        value: function checkWithoutStop(params) {
            var _this2 = this;

            log('Checking departure availability without the stop.');

            var r = this.departureService.checkDeparture(params.dc, params.bd, params.ed);
            r.then(function (blockers) {
                if (blockers === null) {
                    // Canceled
                } else if (blockers.length === 0) {
                    // The departure is available without the stop. Ask for a different stop.
                    log('The departure is available without the stop.');
                    _this2.askStop(params);
                } else {
                    // The departure isn't available without the stop either.
                    log('The departure is also unavailable without the stop.');
                    log('Showing the unavailability notice.');
                    _this2.showUnavailable = true;
                }
            });
        }
    }, {
        key: 'askStop',
        value: function askStop(params) {
            var _this3 = this;

            log('Asking for a stop.');

            var modal = this.$uibModal.open({
                template: require('./winresAskStop.html'),
                component: 'winresAskStop',
                resolve: {
                    depDestCode: function depDestCode() {
                        return params.dc;
                    },
                    depBeginDate: function depBeginDate() {
                        return params.bd;
                    },
                    depEndDate: function depEndDate() {
                        return params.ed;
                    }
                },

                // Don't allow closing it by clicking the backdrop or pressing ESC
                backdrop: 'static',
                keyboard: false
            });

            modal.result.then(function () {
                log('Stop ID provided.');
                // Re-read the changed URL parameters.
                var params = _this3.urlService.readUrlParams(true);

                _this3.checkWithStop(params);
            });
        }
    }]);

    return WinresAskController;
}();

WinresAskController.$inject = ['$uibModal', 'urlService', 'departureService'];

_module3.default.component('winresAsk', {
    transclude: true,
    template: '<ng-transclude ng-if="$ctrl.showContent"></ng-transclude><p ng-if="$ctrl.showUnavailable" ng-i18next>winres_departures.not_available</p>',
    controller: WinresAskController
});

var WinresAskStopController = function () {
    function WinresAskStopController($scope, $location, $window) {
        _classCallCheck(this, WinresAskStopController);

        this.$scope = $scope;
        this.$location = $location;
        this.$window = $window;
    }

    _createClass(WinresAskStopController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this4 = this;

            this.stopID = undefined;

            this.$scope.$watch(function () {
                return _this4.stopID;
            }, function () {
                return _this4.setValidity();
            });
        }
    }, {
        key: 'setValidity',
        value: function setValidity() {
            var form = this.$scope.form;
            if (form) {
                this.$scope.form.$setValidity('stop', this.stopID !== undefined);
            }
        }
    }, {
        key: 'go',
        value: function go() {
            if (this.stopID === undefined) {
                this.setValidity();
            }

            // Temporary hack, proper solution is to ask backend for the URL
            // or use UI-Router in the frontend to construct it.
            var path = this.$location.path() || '';
            if (path.length > 0 && path[path.length - 1] != '/') {
                path += '/';
            }
            this.$location.path(path + this.stopID);

            this.close();
        }
    }]);

    return WinresAskStopController;
}();

WinresAskStopController.$inject = ['$scope', '$location', '$window'];

_module3.default.component('winresAskStop', {
    template: require('./winresAskStop.html'),
    controller: WinresAskStopController,
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    }
});


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresAsk/winresAsk.js
// module id = 305
// module chunks = 2